export default {
    entityKey: 'accounts',
    titles: {
        singular: 'Account',
        plural: 'Accounts'
    }
}